
import React,{ useEffect } from 'react'
import { useHistory } from "react-router-dom"
import Button from '../../components/Button'
import Card from '../../components/Card'
import { ReactComponent as BackButton } from '../../assets/icons/ui/BackButton.svg'
const CallIcom = require('../../assets/icons/modal/call-us.svg')
const Email = require('../../assets/icons/modal/email.svg')
const Globe = require('../../assets/icons/modal/globe.svg')

const NonNGContacts = () =>{
  const history = useHistory()
  useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  return(
    <section className="nonNGCOntainer">
      <h1 className="report-outage__title"> Streetlight Municipal Directory  </h1>
      <section className="contactTableview">
        <Card className="contactsHeader">
          <div className="contactCityHeader">
            City/Town
          </div>
          <div className="contactContactHeader">
            Contact
          </div>
          <div className="contactInfoHeader">
            Contact Information
          </div>
        </Card >
        <Card className="contactsDetails">
          <div className="contactCityDetails">
            Albany
          </div>
          <div className="contactContactDetails">
            City of Albany
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15184199856">518-419-9856</a> 
            <br/>
            <img src={Globe} className="modal-contact-icon" alt="globe" /><a className='modal-anchortag' rel="noreferrer noopener" href="https://albanynewyork.maps.arcgis.com/apps/MapSeries/index.html?appid=9ed40a07f7994341bc3d6dcb01ae4d23" target="_blank">City of Albany Website</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Chautauqua Institution
          </div>
          <div className="contactContactDetails">
          Chautauqua Utility District
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+17163575856">716-357-5856</a> 
            <br/>
            <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:cud@netsync.net">cud@netsync.net</a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          City of Cortland
          </div>
          <div className="contactContactDetails">
          City of Cortland Public Safety Department
          </div>
          <div className="contactInfoDetails">
            <img src={Globe} className="modal-contact-icon" alt="globe" /><a className='modal-anchortag' rel="noreferrer noopener" href="http://www.cortland.org/FormCenter/Public-Safety-Department-5/Street-Lights-Out-44" target="_blank">City of Cortland</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Dunkirk
          </div>
          <div className="contactContactDetails">
          Department of Public Works
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+17163669832">716-366-9832 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          City of Glens Falls
          </div>
          <div className="contactContactDetails">
          Tom Jirard 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15187613834">518-761-3834</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Gloversville
          </div>
          <div className="contactContactDetails">
          Rex Perkins/Jason Munn 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15187757131">518-775-7131/518-224-1985</a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:dpwdir@cityofgloversville.com">dpwdir@cityofgloversville.com</a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          City of Oneida
          </div>
          <div className="contactContactDetails">
          Shelly Tompkins, City Engineer Office
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153637222">315-363-7222 </a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Syracuse
          </div>
          <div className="contactContactDetails">
          City Line
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13154488360">315-448-CITY / 315-448-8360</a>
          </div>
        </Card> 
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          City of Tonawanda
          </div>
          <div className="contactContactDetails">
          Chuck Gilbert
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+17166958645">716-695-8645</a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:adminassist@tonawandacity.com">adminassist@tonawandacity.com</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Utica
          </div>
          <div className="contactContactDetails">
          Matt Faffley
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13158808147">315-880-8147 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          City of Rome
          </div>
          <div className="contactContactDetails">
          Tracy Millner
          <br/>
          <br/>
          Butch Conover
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153397649">315-339-7649 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:tmillner@romecitygov.com">tmillner@romecitygov.com </a>
            <br/><img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153397625">315-339-7625 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:bconover@romecitygov.com">bconover@romecitygov.com </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          City of Cohoes
          </div>
          <div className="contactContactDetails">
          Cohoes Department of Public Works
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15182332139">518-233-2139</a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:DPW@ci.cohoes.ny.us">DPW@ci.cohoes.ny.us</a>
          </div>
        </Card>
        <Card className="contactsDetails">
        <div className="contactCityDetails">
        Town of Cortlandville
        </div>
        <div className="contactContactDetails">
        John Delvecchio
        </div>
        <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+16077587922">607-758-7922</a>
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:Jdelvecchio@cortlandville.org">Jdelvecchio@cortlandville.org</a>
        </div>
        </Card>
        <Card className="contactsDetails">
        <div className="contactCityDetails">
        Town of New Hartford
        </div>
        <div className="contactContactDetails">
        Paul Miscione
        </div>
        <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13157337500">315-733-7500</a>
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:pmiscione@townofnewhartfordny.gov">pmiscione@townofnewhartfordny.gov</a>        
        </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Town of Clifton Park
          </div>
          <div className="contactContactDetails">
          Clifton Park, Buildings and Grounds Department
          </div>
          <div className="contactInfoDetails">
        <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:dclemens@cliftonpark.org">dclemens@cliftonpark.org</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Eden
          </div>
          <div className="contactContactDetails">
          Marlene Grunder
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+17169923408">716-992-3408 x120 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:marlene@edenny.gov">marlene@edenny.gov</a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Town of Salina
          </div>
          <div className="contactContactDetails">
          Town of Salina
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13154576661">315-457-6661 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Town of Grand Island
          </div>
          <div className="contactContactDetails">
          Town Highway Department
          </div>
          <div className="contactInfoDetails">
           <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:streetlights@grand-island.ny.us">streetlights@grand-island.ny.us</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Skaneateles 
          </div>
          <div className="contactContactDetails">
          Town Clerk 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13156853473">315-685-3473</a>
          </div>
        </Card>           
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Town of Tonawanda
          </div>
          <div className="contactContactDetails">
          Randy Pekarski, Project Engineer
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+17168778805">716-877-8805 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:rpekarski@tonawanda.ny.us">rpekarski@tonawanda.ny.us</a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Town of Wilna
          </div>
          <div className="contactContactDetails">
          Paul H. Smith,Town Supervisor
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13157839192">315-783-9192 </a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Lysander
          </div>
          <div className="contactContactDetails">
          Al Yager
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13158570291">315-857-0291 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:engineer@townoflysander.org">engineer@townoflysander.org</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Amherst
          </div>
          <div className="contactContactDetails">
          Al Spoth
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+1716-631-7117">716-631-7117 </a>
            <br/>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Altamont
          </div>
          <div className="contactContactDetails">
          Kerry Dineen
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15188618554">518-861-8554 x10 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:mayordineen@gmail.com">mayordineen@gmail.com</a>          
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Wellsville
          </div>
          <div className="contactContactDetails">
          Village Electric Dept.
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15855961735">585-596-1735 </a>        
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Northville
          </div>
          <div className="contactContactDetails">
          Carm Greco
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15187623103">518-762-3103 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:carmgreco@gmail.com">carmgreco@gmail.com</a>          
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Deferiet
          </div>
          <div className="contactContactDetails">
          Joseph Russell
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13154137116">315-413-7116 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:jrussell@barclaydamon.com">jrussell@barclaydamon.com</a>          
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Carthage
          </div>
          <div className="contactContactDetails">
          Village of Carthage Offices
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13154931060">315-493-1060 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Lowville
          </div>
          <div className="contactContactDetails">
          Mayor Joseph Beagle
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153762834">315-376-2834 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Croghan
          </div>
          <div className="contactContactDetails">
          Mitch Robinson, DPW Supervisor
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15028895013">502-889-5013 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Adams
          </div>
          <div className="contactContactDetails">
          Tony Fredrick
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13157781068">315-778-1068 </a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Brockport
          </div>
          <div className="contactContactDetails">
          Harry Donahue, Superintendent of Public Works
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15856371060">585-637-1060 x301  </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:hdonahue@brockportny.org">hdonahue@brockportny.org</a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Cazenovia 
          </div>
          <div className="contactContactDetails">
          Village DPW
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13156553041">315-655-3041 </a>
          </div>
        </Card> 
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Homer
          </div>
          <div className="contactContactDetails">
          Mike Harter
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+16077452414">607-745-2414 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Lima
          </div>
          <div className="contactContactDetails">
          Ben Luft, Director of Public Works 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15853707143">585-370-7143</a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:Bluft@villageoflima.us">Bluft@villageoflima.us</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Medina
          </div>
          <div className="contactContactDetails">
          Village of Medina Public Works
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15857980710 ">585-798-0710 </a> 
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:publicworks@villagemedina.org">publicworks@villagemedina.org</a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Scotia
          </div>
          <div className="contactContactDetails">
          Andy Boniewski, DPW Crew Leader
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15187885832">518-788-5832 </a>
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Town of Martinsburg
          </div>
          <div className="contactContactDetails">
          Tyler Jones
          <br/>
          Mary Kelley
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153762309">315-376-2309 </a>
            <br/><img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153762299">315-376-2299 </a>
          </div>
        </Card>
		    <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of West Carthage
          </div>
          <div className="contactContactDetails">
          Village Office
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13154932552">315-493-2552 </a>
          </div>
        </Card>
		    <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Sackets Harbor
          </div>
          <div className="contactContactDetails">
          Mayor, Eric Constance 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13154084822">315-408-4822 </a>
          </div>
        </Card>
		    <Card className="contactsDetails">
          <div className="contactCityDetails">
          Town of Adams
          </div>
          <div className="contactContactDetails">
          Richard Walden 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13157784281">315-778-4281 </a>
          </div>
        </Card>
		    <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Copenhagen
          </div>
          <div className="contactContactDetails">
          Richard Ross, DPW Superintendent 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13156884229">315-688-4229 </a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Waddington
          </div>
          <div className="contactContactDetails">
          Chris Reagan, DPW Supervisor
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13152768155">315-276-8155 </a> 
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:chrisrgn@gmail.com">chrisrgn@gmail.com</a>
          </div>
        </Card>       
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Liverpool
          </div>
          <div className="contactContactDetails">
          Village Clerk
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13154573441">315-457-3441 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Webb
          </div>
          <div className="contactContactDetails">
          Bonnie Baker
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153695022">315-369-5022 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Canajoharie
          </div>
          <div className="contactContactDetails">
          Village Office
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+1 5186735512">518-673-5512 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Voorheesville
          </div>
          <div className="contactContactDetails">
          Town Clerk
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+5187652692">518-765-2692 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          County of Albany
          </div>
          <div className="contactContactDetails">
          Main Number
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15184477000">518-447-7000 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Perth
          </div>
          <div className="contactContactDetails">
          Town Office
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15188436977">518-843-6977 </a> 
            <br/><img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15188439056">518-843-9056 </a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Dekalb
          </div>
          <div className="contactContactDetails">
          John Frary
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153221863">315-322-1863 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Geddes
          </div>
          <div className="contactContactDetails">
          Supervisor Jerry Albrigo
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13155305648">315-530-5648 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of New Scotland
          </div>
          <div className="contactContactDetails">
          Clerk
          <br/>
          Supervisor
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15184394865">518-439-4865</a> 
          <br/><img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15184394889">518-439-4889</a>          
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Caroga
          </div>
          <div className="contactContactDetails">
          Town Clerk Linda Gilbert
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+151883514211">518-835-4211 X 101 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Colonie
          </div>
          <div className="contactContactDetails">
          Joseph Peregrim 
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+518-786-7338">518-786-7338</a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Guilderland
          </div>
          <div className="contactContactDetails">
          Town Supervisor
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15183561980">518-356-1980 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Pittstown
          </div>
          <div className="contactContactDetails">
          Clerk
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15187534222">518-753-4222 </a> 
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Kenmore
          </div>
          <div className="contactContactDetails">
          Kathleen Johnson
          </div>
          <div className="contactInfoDetails">
            <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:kjohnson@vi.kenmore.ny.us">kjohnson@vi.kenmore.ny.us</a>          
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          City of Little Falls
          </div>
          <div className="contactContactDetails">
          Department of Public Works
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15315-823-0211">315-823-0211 </a>         
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Erie County Medical Center (ECMC)
          </div>
          <div className="contactContactDetails">
          
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15716-898-3000">716-898-3000 </a>          
          </div>
        </Card>
        <Card className="contactsDetails">
          <div className="contactCityDetails">
          Village of Fredonia
          </div>
          <div className="contactContactDetails">
          
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15716-679-2302">716-679-2302 </a>
            <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:fredoniavillageclerk@gmail.com">fredoniavillageclerk@gmail.com</a>          
          </div>
        </Card>
      
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Trenton
          </div>
          <div className="contactContactDetails">
         
          </div>
          <div className="contactInfoDetails">
          <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:supervisor@town.trenton.ny.us">supervisor@town.trenton.ny.us</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Johnstown
          </div>
          <div className="contactContactDetails">
          Supervisor’s Office
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15187627070">518-762-7070 x2 </a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:supervisor@johnstown.org">supervisor@johnstown.org</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Sharon Springs
          </div>
          <div className="contactContactDetails">
          
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15182842625">518-284-2625</a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:Sharonspringsvillage@gmail.com">Sharonspringsvillage@gmail.com</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Evans
          </div>
          <div className="contactContactDetails">
          
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+17162173500">716-217-3500</a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:supervisor@townofevans.org">supervisor@townofevans.org</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Greenwich
          </div>
          <div className="contactContactDetails">
          
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15186922755">518-692-2755</a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:clerk@villageofgreenwich.org">clerk@villageofgreenwich.org</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Barker
          </div>
          <div className="contactContactDetails">
          Village Office
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+1716-795-3777">716-795-3777</a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:barkervillage@roadrunner.com">barkervillage@roadrunner.com</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Avon
          </div>
          <div className="contactContactDetails">
          Village Office
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15852268118">585-226-8118</a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Watervliet
          </div>
          <div className="contactContactDetails">
          Stacey Clermont
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15182703800">518-270-3800 x100 </a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:SClermont@watervliet.com">SClermont@watervliet.com</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Batavia
          </div>
          <div className="contactContactDetails">
          Tom Phelps
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15853456324">585-345-6324 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Fort Plains
          </div>
          <div className="contactContactDetails">
          Dave Briggs
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15189934271">518-993-4271 </a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:Fortplain.clerk@gmail.com">Fortplain.clerk@gmail.com</a>
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Norwood
          </div>
          <div className="contactContactDetails">
          Dan McGregor
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+13153536667">315-353-6667 </a> 
          </div>
        </Card>
        <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Saratoga Springs
          </div>
          <div className="contactContactDetails">
          <br/>  
          Dan Rancour
          <br/>
          <br/>
          Joe O’Neill
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15185873550">518-587-3550 x2920 </a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:Daniel.rancour@saratoga-springs.org">Daniel.rancour@saratoga-springs.org</a>        
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:Joe.oneill@saratoga-springs.org">Joe.oneill@saratoga-springs.org</a>          
          </div>
        </Card>
	 <Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Hudson
          </div>
          <div className="contactContactDetails">
           Department of Public Works
          </div>
          <div className="contactInfoDetails">
            <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+155188289458">518-828-9458 </a> 
          </div>
        </Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Amsterdam
          </div>
          <div className="contactContactDetails">
          Zach Baxter
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+15188414331">518-841-4331 </a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:engineeringprojects@amsterdamny.gov">engineeringprojects@amsterdamny.gov</a>
          </div>
        </Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
            City Of Oswego
          </div>
          <div className="contactContactDetails">
          Ron Cahill, Assistant Commissioner (DPW)
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:3153422511">315-342-2511</a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mailto:rcahill@oswegony.org">rcahill@oswegony.org</a>
        </div>
        </Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Niagara Falls
          </div>
          <div className="contactContactDetails">
        John Kinney Director, Dept. of Parks & Public Works
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+716-286-4940">716-286-4940 (office)</a> 
          <br/><img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+716-994-6916">716-994-6916 (cell)</a> 
          </div>
        </Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Hamburg
          </div>
          <div className="contactContactDetails">
          </div>
          <div className="contactInfoDetails">
          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:+716-648-5111">716-648-5111 ext. 0 </a> 
          <br/>
          </div>
        </Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          City of Fulton
          </div>
          <div className="contactContactDetails">
          Clerk's Office - Misty DeGroat
          </div>
          <div className="contactInfoDetails">

          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:315-592-5390">315-592-5390</a> 
          <br/><img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mdegroat@cityoffulton.com">mdegroat@cityoffulton.com</a>
          </div>

          
        

</Card>
<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Cheektowaga
          </div>
          <div className="contactContactDetails">
          Richard Rusiniak - Highway Supervisor
          </div>
          <div className="contactInfoDetails">

          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:(716) 686-3450">(716) 686-3450</a> 
          <br/><img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:(716) 686-3456">(716) 686-3456</a> 
          <br/>
          <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="RRusiniak@tocny.org">RRusiniak@tocny.org</a>
          </div>

          
        

</Card>

<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Schoharie
          </div>
          <div className="contactContactDetails">
          Leslie Price
          </div>
          <div className="contactInfoDetails">

          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:518-295-8500">518-295-8500(Office)</a> 
          <br/>
          <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="villscho@gmail.com">villscho@gmail.com</a>
          </div>
</Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Town of Henrietta
          </div>
          <div className="contactContactDetails">
          Mike Catalano - Commissioner of Public Work
          </div>
          <div className="contactInfoDetails">

          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:(585) 359-7005">(585) 359-7005</a> 
          <br/>
          <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="dispatch@henrietta.org ">dispatch@henrietta.org </a><br/>
          <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="mcatalano@henrietta.org ">mcatalano@henrietta.org </a>
          </div>

          
        

</Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
         City of Johnstown
          </div>
          <div className="contactContactDetails">
          Chris Vose
          </div>
          <div className="contactInfoDetails">

          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:518-921-1265">518-921-1265</a> 
          <br/>
          
                   </div>

          
        

</Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
          Village of Hoosick Falls
          </div>
          <div className="contactContactDetails">
          Ken Holbrook - DPW Superintendent
          </div>
          <div className="contactInfoDetails">

          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:(518) 848-7156">(518) 848-7156</a> 
          <br/>
          <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="kholbrookwwtp@gmail.com ">kholbrookwwtp@gmail.com </a>
                   </div>

          
        

</Card>
	<Card className="contactsDetails-light">
          <div className="contactCityDetails">
         Village of Broadalbin
          </div>
          <div className="contactContactDetails">
          Barbara Rote: Clerk -Treasurer
          </div>
          <div className="contactInfoDetails">

          <img src={CallIcom} className="modal-contact-icon" alt="call" /> <a className='modal-anchortag' href="tel:518-883-8265">518-883-8265</a> 
          <br/>
          <img src={Email} className="modal-contact-icon" alt="email" /> <a className='modal-anchortag' href="broadalbinvillage@frontiernet.net">broadalbinvillage@frontiernet.net </a>
                   </div>

          
        

</Card>
	






        <div className="contactNotes">* The Chautauqua Utility District (CUD) owns and maintains the streetlights within the grounds of Chautauqua Institution and its main parking lot located across Route 394 from the Main Gate Welcome Center. Note:  National Grid owns and maintains the streetlights within the Town of Chautauqua that are located outside of Chautauqua Institution and the main parking lot.  
        </div>
      </section>
      <section className="report-streetlight__actions">
        <Button
          className={`-secondary cancelButton`}
          aria-label={`Cancel and return to homepage`}
          data-a11y-focus="first"
          onClick={() => history.push('/')}
        >
                  Cancel
        </Button>
        <Button
          className={`button -link-button-back -secondary back`}
          aria-label={`Back`}
          data-a11y-focus="first"
          onClick={() => history.push('/OutageWarning/OutageMap')}
        >
          <BackButton/>
        </Button>
      </section>
    </section>
  )
}
export default NonNGContacts

